import { useTranslation } from "react-i18next";
import styles from './hero.module.scss';
import womanSVG from '../../assets/images/hero-woman.svg';
import manSVG from '../../assets/images/hero-man.svg';

const Hero = () => {

    const { t } = useTranslation();

    const gifts = [
        { price: '฿500', description: t('gift-description1') },
        { price: '฿2000', description: t('gift-description2') },
        { price: '฿3000', description: t('gift-description3') },
    ];

    return (
        <section className={styles.hero}>
            <img src={womanSVG} alt="" className={styles.illustrationLeft} aria-hidden="true" />
            <img src={manSVG} alt="" className={styles.illustrationRight} aria-hidden="true" />

            <div className={styles.hero__content}>
                <span className={styles.badge}>{t('badge-mgm')}</span>

                <h1 className={styles.title}>
                    {t('hero-title-line1')}<br />{t('hero-title-line2')}
                </h1>

                <p className={styles.subtitle}>{t('hero-subtitle')}</p>

                <div className={styles.cards}>
                    {
                        gifts.map(item => (
                            <div className={styles.card} key={item.price}>
                                <span className={styles.card__price}>{item.price}</span>
                                <span className={styles.card__label}>{t('gift-title')}</span>
                                <p className={styles.card__description}>{item.description}</p>
                            </div>
                        ))
                    }
                </div>
            </div>
        </section>
    );
};

export default Hero;
